import Select from 'react-select';
import { SingleFilterClause } from 'store/composableFiltersSlice';

interface PropertyFieldProps {
  selectOptions: any;
  filterState: SingleFilterClause;
  handlePropertyFieldUpdate: Function;
  placement: 'single' | 'group';
}

export const PropertyField = ({
  selectOptions,
  filterState,
  handlePropertyFieldUpdate,
  placement,
}: PropertyFieldProps) => {
  const fieldWidth = placement === 'single' ? 'w-52' : 'w-40';

  const selectBaseStyles = {
    input: (base: any) => ({
      ...base,
      'input:focus': {
        boxShadow: 'none',
      },
    }),
    control: (base: any) => ({
      ...base,
      backgroundColor: '#F8F8F8',
      border: 'none',
      borderRadius: '8px',
      height: '48px',
    }),
    menu: (base: any) => ({
      ...base,
      width: '250px',
      paddingRight: '3px',
    }),
    menuList: (base: any) => ({
      ...base,
      '::-webkit-scrollbar': {
        width: '5px',
      },
      '::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'black',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
    option: (base: any) => ({
      ...base,
      borderBottom: '1px solid #F1F1F1',
    }),
    indicatorSeparator: () => ({}),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: '16px',
    }),
  };

  const formatGroupLabel = (data: typeof selectOptions.property) => (
    <div className="flex items-center justify-between">
      <span>{data.label}</span>
      <span className="px-1.5 text-xs text-white rounded-full bg-segments-darker-gray-75">
        {data.options.length}
      </span>
    </div>
  );

  return (
    <Select
      value={
        !!!filterState.property?.name
          ? null
          : {
              value: filterState.property.name,
              label: filterState.property.display,
            }
      }
      options={selectOptions.properties}
      formatGroupLabel={formatGroupLabel}
      className={` ${fieldWidth}`}
      isLoading={!!!selectOptions?.properties?.length}
      styles={selectBaseStyles}
      onChange={(selectedOption) => handlePropertyFieldUpdate(selectedOption)}
      menuShouldScrollIntoView
    />
  );
};
